import React from 'react';
import moment from 'moment';

function PeriodCell(startDate: any) {
    if (startDate.text === "") {
        return (
            <span></span>
        )
    } else {
        return (
            //<span>{moment(startDate.text).add(7, 'hours').format('HH:mm a')} {moment(startDate.text).add(8, 'hours').format('HH:mm a')}</span>
            <span>{moment(startDate.text).format('HH:mm a')} - {moment(startDate.text).add(15, 'minute').format('HH:mm a')}</span>
        )
    }

}
export default PeriodCell;